function l(e, n) {
  for (var t = -1, h = n.length, f = e.length; ++t < h; )
    e[f + t] = n[t];
  return e;
}
export {
  l as default
};
